import { gql } from '@apollo/client'

const QueryListVirtualAssetType = gql(`
    query listVirtualAssetTypes($filter: ListAssetTypesFilterInput $limit: Int $nextToken: String $project: String $module: String!){
        listVirtualAssetTypes( 
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            project: $project
            module : $module
        ) {
        items {
            id
            title
            position
            isActive
            isDefault
            isLveToVodSupported
            isMatchRelated
            autoPublish
            videoSection
            fileSection
            contentSection
            programSection
            authorSection
            matchSection
            usedCount
            entertainmentMetadata
            creditSection
            parentalRatingSection
            assetTypeCategory
            metaFields{
                id
                supportedFileTypes
                tooltip
                displayTitle
                displayName
                type
                isRequired
                values
                section{
                    id
                    title
                }
            }
            icon{
                id
                url
                fileName
                name
                aspectRatio {
                    aspectRatio
                    ratio
                    title          
                    resolutions {
                      url
                    }
                }
                settings {
                    aspectRatio
                    outputFormat
                    fileName
                    x1
                    y1
                    x2
                    y2          
                }
            }
            draftIcon{
                id
                url
                fileName
                name
                aspectRatio {
                    aspectRatio
                    ratio
                    title          
                    resolutions {
                      url
                    }
                }
                settings {
                    aspectRatio
                    outputFormat
                    fileName
                    x1
                    y1
                    x2
                    y2          
                }
            }
        }
        nextToken
    }
}`)

export default QueryListVirtualAssetType
